module.exports = __webpack_public_path__ + "static/media/listEmgeaMobile.4a1aa15c.png";